export const state = () => ({
  page: {
    title: '',
  },
  user: {},
})

export const actions = {
  async getUserInfos({ commit }, options = {}) {
    try {
      const { data } = await this.$axios.get('/v2/auth/app/me')
      commit('setUserInfo', data)
      return data
    } catch (e) {
      $nuxt.$telemetry.pushEvent({
        category: 'layout',
        name: 'getUserInfos',
        error: e,
        options,
      })
      if (options.throwError) throw e
    }
  },
}

export const mutations = {
  setPageTitle(state, title) {
    state.page.title = title
  },
  setUserInfo(state, data) {
    state.user = data
  },
}
